import { mapGetters } from "vuex";
import { debounce } from "lodash";
import { setSuiAptosTokenProperty, getUTC, updateOptional, multiply } from "../utils";
import { reqSwapMarketSearch, reqSwapMarketHotList } from "../api";
import parseNumber from "./parseNumber";
import swapMarketToken from './swapMarketToken';

let controller = null;

export default {
  mixins: [parseNumber, swapMarketToken],
  data() {
    return {
      debouncerSearch: null,
      swapMarketSearchStatus: '',
      swapMarketSearchInput: '',
      swapMarketTokenMap: {},
      searchHistoryKeys: [],
      hotTokenList: [],
      loadingHotToken: false,
    }
  },
  computed: {
    ...mapGetters(['blockchainList', 'utc_type', 'localOptionalList']),
    deleteHistoryImg() {
      return require(`../assets/search/delete${this.darkModeImg}.png`);
    },
    searchEmptyImg() {
      return require(`../assets/search/search-empty${this.darkModeImg}.png`);
    },
  },
  watch: {
    swapMarketSearchInput(val) {
      this.searchHistoryKeys = this.getSearchHistoryKeys()
    }
  },
  methods: {
    setHistoryTokens() {
      if (!this.searchHistoryTokens || !this.searchHistoryTokens.length) return;
      const headerData = { os: 'web', utc_type: this.utc_type }
      this.searchHistoryTokens.forEach(historyToken => {
        const data = { key: historyToken.address }
        reqSwapMarketSearch(data, headerData).then(res => {
          if (res.result === 0 && res.data) {
            let token = res.data.find(
              (item) =>
                item.address.toLowerCase() === historyToken.address.toLowerCase() &&
                item.network === historyToken.network
            );
            if (token) {
              token.price = this.parsePrice(token.price)
              const change = Math.round(token.chg * 10000) / 100;
              token.change = `${token.chg > 0 ? '+' : ''}${change}%`;
              token.chg = multiply(token.chg, 100).toFixed(2)
              this.setNetworkLogo(token);
              const { isMoveAddress, moveAddress } = setSuiAptosTokenProperty(token)
              if (isMoveAddress) {
                token.isMoveAddress = isMoveAddress
                token.moveAddress = moveAddress
              }
              for (let key in token) {
                historyToken[key] = token[key];
              }
              localStorage.setItem(
                'searchHistoryTokens',
                JSON.stringify(this.searchHistoryTokens)
              );
            }
          }
        })
      })
    },
    getHotSwapTokens() {
      this.loadingHotToken = true;
      const headerData = { os: 'web', utc_type: this.utc_type }
      reqSwapMarketHotList(headerData).then(res => {
        if (res.result === 0 && res.data) {
          this.hotTokenList = this.initSearchTokens(res.data) || [];
        }
      })
      .finally(() => {
        this.loadingHotToken = false;
      })
    },
    searchSwapMarket(input) {
      // console.log('searchSwapMarket', input);
      if (this.swapMarketSearchInput !== input) return;
      let searchHistoryKeys = this.getSearchHistoryKeys()
      const searchKey = searchHistoryKeys.find((item) => item === input)
      if (!searchKey) {
        searchHistoryKeys.unshift(input)
        if (searchHistoryKeys.length > 10) {
          searchHistoryKeys.pop()
        }
        localStorage.setItem('searchHistoryKeys', JSON.stringify(searchHistoryKeys))
      }
      const headerData = { os: 'web', utc_type: this.utc_type }
      const data = { key: input }
      if (controller) {
        controller.abort();
      }
      // 创建新的 AbortController
      controller = new AbortController();
      const signal = controller.signal;
      reqSwapMarketSearch(data, headerData, signal).then(res => {
        if (res.result === 0 && res.data && Array.isArray(res.data) && res.data.length) {
          this.swapMarketTokenMap = this.initSearchTokens(res.data, 'search') || {};
          this.swapMarketSearchStatus = 'data';
        } else {
          this.swapMarketSearchStatus = 'noData';
        }
      }).catch(err => {
        console.log(err);
        this.swapMarketSearchStatus = 'noData';
      })
    },
    initSearchTokens(data, type) {
      // console.log('initSearchTokens', structuredClone(data));
      if (!Array.isArray(data)) {
        return undefined
      }
      const map = {};
      let list = data.slice(0, 10);
      if (type === 'search') {
        list = data
      }
      list.forEach((item, index) => {
        const change = Math.round(item.chg * 10000) / 100;
        item.change = `${item.chg > 0 ? '+' : ''}${change}%`;
        item.chg = multiply(item.chg, 100)
        item.price_usd = item.price;
        item.price = this.parsePrice(item.price);
        if (type === 'search') {
          item.order = undefined
        } else {
          item.order = index + 1
        }
        item.marketValueList = [
          {
            label: 'LIQ',
            value: this.parseWithUnit(item.market_value)
          },
          {
            label: '24H VOL',
            value: this.parseWithUnit(item.volume)
          },
          {
            label: 'FDV',
            value: this.parseWithUnit(item.market_cap)
          },
        ]
        let chg_info = item.period_token_stat_info?.period_chg_info
        if (chg_info) {
          item.chg_1h = chg_info['1h'] !== undefined && multiply(chg_info['1h'], 100)
          item.chg_24h = chg_info['24h'] !== undefined && multiply(chg_info['24h'], 100)
        }
        this.setNetworkLogo(item);
        const { isMoveAddress, moveAddress } = setSuiAptosTokenProperty(item)
        if (isMoveAddress) {
          item.isMoveAddress = isMoveAddress
          item.moveAddress = moveAddress
        }
        if (!map[item.blockchain_name]) {
          map[item.blockchain_name] = [item];
        } else {
          map[item.blockchain_name].push(item);
        }
      });
      if (type === 'search') {
        return map
      } else {
        return list
      }
    },
    /** 添加/删除自选代币 */
    async onOptional(token, flag) {
      // console.log('token', token);
      // console.log('flag', flag);
      const { address, blockchain_id, bl_symbol } = token
      const utc_type = getUTC()
      const swapToken = await this.getSwapMarketClassOptional([{ address, blockchain_id, bl_symbol }], utc_type);
      // console.log('swapToken', swapToken);
      if (swapToken.length) {
        this.$store.commit('setLocalOptionalList', this.localOptionalList)
        updateOptional(this.localOptionalList, swapToken[0])
        // this.updateTokenList()
      } else {
        // this.$notify({ text: this.$t("failed"), type: "error" });
      }
    },

    debounceQuerySearch() {
      if (!this.debouncerSearch) {
        this.debouncerSearch = debounce(this.searchSwapMarket, 500);
      }
      this.debouncerSearch(...arguments);
    },
    onSearchHistoryKey(key) {
      this.swapMarketSearchInput = key
      this.swapMarketInputChange()
    },
    swapMarketInputChange() {
      if (!this.swapMarketSearchInput) {
        this.swapMarketTokenMap = {};
        return;
      }
      this.swapMarketSearchStatus = 'loading';
      this.debounceQuerySearch(this.swapMarketSearchInput);
    },
    onDelete() {
      localStorage.removeItem('searchHistoryKeys')
      this.searchHistoryKeys = []
      this.$mitt.emit('clear-search-history-tokens')
    },
    getSearchHistoryKeys() {
      let searchHistoryKeys = localStorage.getItem('searchHistoryKeys')
      if (searchHistoryKeys) {
        searchHistoryKeys = JSON.parse(searchHistoryKeys)
      } else {
        searchHistoryKeys = []
      }
      return searchHistoryKeys
    },
  },
};
